import React from "react";
import styles from "./Login.module.scss";
import { Link, Outlet } from "react-router-dom";
import { FiChevronLeft } from "react-icons/fi";
import Icon, { IconWrapper } from "components/Icon/Icon";
import logoSeduc from "assets/images/canaleducacao/logo-seduc-horizontal.png";

export default function LoginLayout(props) {
  const { children, back, contentWidth = 500, contentMinWidth } = props;

  // min(Npx, 100%) instead of a bare Npx floor - on narrow/mobile viewports
  // this backs off to 100% instead of forcing an overflow; on wider screens
  // it enforces the real floor so long content (e.g. an institutional
  // e-mail + its buttons) doesn't wrap. Has to be applied to BOTH .main and
  // .container: .main's own "100%" resolves against .container's box, which
  // defaults to a fixed 50% of the viewport - widening only .main just gets
  // clamped back down to whatever width .container already has. .container
  // and .figure are unconstrained flex siblings (no flex-shrink:0), so
  // giving .container a floor only shrinks the banner to make room instead
  // of overflowing/overlapping it.
  const mainStyle = { width: contentWidth };
  const containerStyle = {};
  if (contentMinWidth) {
    mainStyle.minWidth = `min(${contentMinWidth}px, 100%)`;
    containerStyle.minWidth = `min(${contentMinWidth}px, 100%)`;
  }

  const appName = process.env.REACT_APP_NAME;
  const logo = require(`assets/images/${appName}/horizontal-logo.svg`);
  const banner = require(`assets/images/${appName}/login.jpg`);

  return (
    <div className={styles.login}>
      <div className={styles.container} style={containerStyle}>
        <main className={styles.main} style={mainStyle}>
          <div
            className={styles.header}
            // style={{
            //   textAlign: "center",
            //   display: "flex",
            //   flexDirection: "column",
            //   alignItems: "center",
            // }}
          >
            {back && (
              <Link className={styles.back} to={back}>
                <IconWrapper>
                  <Icon>
                    <FiChevronLeft />
                  </Icon>
                </IconWrapper>
                Voltar
              </Link>
            )}

            {/* RETORNAR APÓS PERÍODO ELEITORAL */}
            {/* <img src={logo} alt="Logotipo" className={styles.logo} /> */}

            <img src={logoSeduc} alt="Logotipo" style={{ width: "450px" }} />
            {/* <h1>Plataforma de ensino do Canal Educação</h1> */}
            <h1>Plataforma de ensino</h1>
          </div>

          {children}

          <Outlet />
        </main>
      </div>

      <figure className={styles.figure}>
        <img
          src={banner}
          alt="imagem do banner"
          aria-hidden="true"
          className={styles.image}
        />
      </figure>
    </div>
  );
}
